module.exports = __webpack_public_path__ + "img/zuijia_25.b50e4642.png";